import { IBusinessPriorityApi } from '../api/types'
import {
  IBusinessPriority,
  TBusinessPriorityAction,
  TBusinessPriotityProgramOffering,
} from '../model/types'

import { parseSeparatedString } from './parseSeparatedString'

export const mapBusinessPriorityFromApi = (data: IBusinessPriorityApi): IBusinessPriority => ({
  availableActions: parseSeparatedString(data.AvailibleActions) as TBusinessPriorityAction[],
  uid: data.UID,
  name: data.Name,
  description: data.Description,
  markets: parseSeparatedString(data.Markets),
  programOfferings: parseSeparatedString(data.Offerings) as TBusinessPriotityProgramOffering[],
  fYear: data.FYear,
  kiCount: data.KICount ?? 0,
  creator: data.CreatedBy,
  status: data.Status,
  // TODO: exact API shape of ChangeLog entries is not confirmed yet
  changeLog: (data.ChangeLog ?? []).map((entry) => ({
    timestamp: entry.Timestamp,
    changedBy: entry.ChangedBy,
    field: entry.Field,
    oldValue: entry.OldValue,
    newValue: entry.NewValue,
  })),
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
})
